export const categories = {
  Reading: 1,
  Writing: 2,
  Math: 3,
  ReadingOrWriting: 4,
};

export const testTimes = {
  SchoolYearBegin: 1,
  SchoolYearMiddle: 2,
  SchoolYearEnd: 3,
};

export const education = {
  Elementary: 1,
  Middle: 2,
  High: 3,
};

export const classes = {
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5,
  sixth: 6,
};

export const diagnosticResults = {
  Blue: 1,
  Yellow: 2,
  Yellow_NoDiagnosticDesired: 3,
  Green: 4,
};

export const competenceLevels = {
  NotSpecified: -1,
  NoSupport: 35, //Kein Förderbedarf, >30
  LowSupport: 25, //Niedriger Förderbedarf, 21-30
  MediumSupport: 15, //Mittlerer Förderbedarf, 11-20
  HighSupport: 5, //Hoher Förderbedarf, 0-10
};

//use this method to translate the diagnostic result option to the text value
export const getDiagnosticResultText = (result) => {
  if (result === undefined) return null;
  if (typeof result === 'boolean') return '';
  switch (result) {
    case diagnosticResults.Blue:
      return 'Blau - unterdurchschnittliches Screeningergebnis';

    case diagnosticResults.Yellow:
      return 'Gelb - wahrscheinlich unterdurchschnittliches Screeningergebnis (Diagnostik erwünscht)';
    case diagnosticResults.Yellow_NoDiagnosticDesired:
      return 'Gelb - wahrscheinlich unterdurchschnittliches Screeningergebnis (Diagnostik unerwünscht)';

    case diagnosticResults.Green:
      return 'Grün - durchschnittliches oder gutes Screeningergebnis';

    default:
      throw new Error('Invalid diagnostic');
  }
};

export const getCompetenceLevels = (result) => {
  if (result === undefined || result === null) return null;
  if (typeof result === 'boolean') return '';
  // Handle NO_VALUE (-99) and other invalid values
  if (result < 0 && result !== competenceLevels.NotSpecified) return 'Nicht vorhanden';
  switch (result) {
    case competenceLevels.NotSpecified:
      return 'Keine Angabe';

    case competenceLevels.NoSupport:
      return 'Kein Förderbedarf';
    case competenceLevels.LowSupport:
      return 'Niedriger Förderbedarf';

    case competenceLevels.MediumSupport:
      return 'Mittlerer Förderbedarf';
    case competenceLevels.HighSupport:
      return 'Hoher Förderbedarf';

    default:
      // For any other numeric value, try to categorize by PR ranges
      if (result > 30) return 'Kein Förderbedarf';
      if (result > 20) return 'Niedriger Förderbedarf';
      if (result > 10) return 'Mittlerer Förderbedarf';
      if (result >= 0) return 'Hoher Förderbedarf';
      return 'Unbekannt';
  }
};

export const getTestTime = (result) => {
  switch (result) {
    case testTimes.SchoolYearBegin:
      return 'Anfang (bis 6 Wochen vor Halbjahrsende)';
    case testTimes.SchoolYearMiddle:
      return 'Mitte (bis 6 Wochen vor Schuljahresende)';
    case testTimes.SchoolYearEnd:
      return 'Ende (bis 6 Wochen vor Schuljahresende inkl. Sommerpause)';

    default:
      throw new Error('Invalid test time');
  }
};
export const getEducation = (result) => {
  switch (result) {
    case education.Elementary:
      return 'Vorschule';
    case education.Middle:
      return 'Grundschule';
    case education.High:
      return 'Sekundarstufe';

    default:
      throw new Error('Invalid test time');
  }
};

export const getClass = (result) => {
  switch (result) {
    case classes.first:
      return '1.Klasse';

    case classes.second:
      return '2.Klasse';
    case classes.third:
      return '3.Klasse';

    case classes.fourth:
      return '4.Klasse';

    case classes.fifth:
      return '5.Klasse';

    case classes.sixth:
      return '6.Klasse';

    default:
      throw new Error('Invalid class');
  }
};

export const competenceSubtopics = {
  DV: 'Sprachwahrnehmung',
  DW: 'Lautwahrnehmung',
  DX: 'Silbengliederung',
  DY: 'Reime (m\u00fcndlich)',
  DZ: 'Laut-Buchstabe-Beziehung',
  EA: 'H\u00e4ufige Buchstabenkombinationen',
  EB: 'Konsonantencluster',
  EC: 'Silben',
  ED: 'Morpheme',
  EE: 'Lauttreue W\u00f6rter',
  EF: 'Pseudow\u00f6rter',
  EG: 'Reime (schriftlich)',
  EH: 'Wortlesen',
  EI: 'W\u00f6rterschreiben',
  EJ: 'Blitzlesen',
  EK: 'Orthographie',
  EL: 'Grammatik',
  EM: 'Satzlesen',
  EN: 'S\u00e4tze schreiben',
  EO: 'Textlesen',
  EP: 'Metakognition',
  EQ: 'Schreibschrift',
  ER: 'Zahlwortabfolgekenntnis',
  ES: 'Mengenverarbeitung',
  ET: 'Zahl-Mengen-Verkn\u00fcpfung',
  EU: 'Relationen',
  EV: 'Teil-Teil-Ganzes-Konzept',
  EW: 'Objektgebundenes Rechnen',
  EX: 'Nicht objektgebundenes Rechnen',
  EY: 'Aufbau Faktenwissen',
  EZ: 'Schriftliches Rechnen',
  FA: 'Textaufgaben',
  FB: 'Zahlenreihen',
  FC: 'Umgang mit Ma\u00dfeinheiten',
  FD: 'Geometrie',
  FE: 'Basiskompetenzen Lesen/Schreiben n\u00e4her spezifizierbar',
  FF: 'Erstes Lesen/Schreiben n\u00e4her spezifizierbar',
  FG: 'Lesen n\u00e4her spezifizierbar',
  FH: 'Schreiben n\u00e4her spezifizierbar',
  FI: 'Angewandtes Lesen n\u00e4her spezifizierbar',
  FJ: 'Angewandtes Schreiben n\u00e4her spezifizierbar',
  FK: 'Basiskompetenzen Rechnen n\u00e4her spezifizierbar',
  FL: 'Erstes Rechnen n\u00e4her spezifizierbar',
  FM: 'Rechnen n\u00e4her spezifizierbar',
  FN: 'Angewandtes Rechnen n\u00e4her spezifizierbar',
};
